import { WebMercatorViewport } from "@deck.gl/core";

export default function bboxToViewState(currentViewState, bbox, options) {
  const [minX, minY, maxX, maxY] = bbox;
  const v = new WebMercatorViewport(currentViewState);
  const { latitude, longitude, zoom } = v.fitBounds(
    [
      [minX, minY],
      [maxX, maxY],
    ],
    options
  );
  return { latitude, longitude, zoom };
}
